class Enum {
    constructor(members) {
        for (const key of Object.keys(members)) {
            this[key] = { name: key, value: members[key] };
        }
    }

    getName(value) {
        return Object.keys(this).find((key) => {
            const member = this[key];
            if (member.value === value) {
                return member.name;
            }
            return false;
        });
    }
}

// Backend enums (to be 1-1 synced with app.lib.enums)
export const DocumentFolder = new Enum({
    INBOX: '6001',
    OUTGOING: '6002',
    CONTRAGENT_MISSING: '6003',
    HAS_COMMENTS: '6004',
    IMPORTED: '6005',
    WAIT_MY_SIGNATURE: '6006',
    INTERNAL: '6007',
    NOT_INTERNAL: '6008',
});

export const UserRole = new Enum({
    USER: 8000,
    ADMIN: 8001,
});

export const CommentStatus = new Enum({
    COMMENT_ORDINARY: 9000,
    COMMENT_REJECT: 9001,
});

export const HTTPStatus = new Enum({
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
});

export const FeatureFlags = new Enum({
    ES_SEARCH: 'ES_SEARCH',
    // remove after remove ENABLE_KEP_SUPER_MASS_SIGN flag
    ENABLE_KEP_SUPER_MASS_SIGN: 'ENABLE_KEP_SUPER_MASS_SIGN',
});

// Application
export const ApplicationMode = new Enum({
    DEFAULT: 'default',
    SIGN_SESSION: 'signSession',
    SHARED_DOCUMENT_VIEW: 'sharedDocumentView',
});

// Statuses
export const CheckKeyPopupStatus = new Enum({
    READ_INFO: 'READ_INFO',
    UPLOAD_PRIVATE_KEY: 'UPLOAD_PRIVATE_KEY',
    CHECK_PRIVATE_KEY: 'CHECK_PRIVATE_KEY',
    CHECK_USB_KEY: 'CHECK_USB_KEY',
    CHECK_IIT_WIDGET_KEY: 'CHECK_IIT_WIDGET_KEY',
    PRIVATE_KEY_CONFIRMATION: 'PRIVATE_KEY_CONFIRMATION',
    ERROR: 'ERROR',
    KEP_ERROR: 'KEP_ERROR',
    DIIA_VERIFICATION: 'DIIA_VERIFICATION',
    KEP_VERIFICATION: 'KEP_VERIFICATION',
});

export const SendPopupStatus = new Enum({
    READY: 'READY',
    ON_SENDING: 'ON_SENDING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    SEND_REQUIRED_FIELDS_ERROR: 'SEND_REQUIRED_FIELDS_ERROR',
});

export const SignPopupStatus = new Enum({
    INIT: 'INIT',
    DELNOT_WARNING: 'DELNOT_WARNING',
    CHOOSE_RECIPIENT: 'CHOOSE_RECIPIENT',
    CHOOSE_DOCUMENT_FIELDS: 'CHOOSE_DOCUMENT_FIELDS',
    CREATE_FLOWS: 'CREATE_FLOWS',
    DIIA_SIGN: 'DIIA_SIGN',
    KEP_SIGN: 'KEP_SIGN',
    UPLOAD_PRIVATE_KEY: 'UPLOAD_PRIVATE_KEY',
    CHECK_PRIVATE_KEY: 'CHECK_PRIVATE_KEY',
    CHECK_USB_KEY: 'CHECK_USB_KEY',
    SIGN_IIT_WIDGET: 'SIGN_IIT_WIDGET',
    SIGN_IN_PROGRESS: 'SIGN_IN_PROGRESS',
    AFTER_SIGN: 'AFTER_SIGN',
    SIGN_CONNECTION_ERROR: 'SIGN_CONNECTION_ERROR',
    MULTI_SIGN_ERROR: 'MULTI_SIGN_ERROR',
    SIGNED_SUCCESSFUL: 'SIGNED_SUCCESSFUL',
    SIGN_ERROR: 'SIGN_ERROR',
    SHARED_DOCUMENT_VIEW_OVERDRAFT_ERROR:
        'SHARED_DOCUMENT_VIEW_OVERDRAFT_ERROR',
});

export const SignSessionStatus = new Enum({
    CREATED: 'created',
    STARTED: 'started',
    CANCELLED: 'cancelled',
    FINISHED: 'finished',
});

export const SignSessionSource = new Enum({
    API: 'api',
    EDI: 'edi',
    XML2PDF: 'xml2pdf',
    INBOX: 'inbox',
});

export const DocumentReviewType = new Enum({
    APPROVE: 'approve',
    REJECT: 'reject',
});

export const DocumentSort = new Enum({
    DATE_LISTING: 'date_listing',
    DATE_DOCUMENT: 'date_document',
    DATE_CREATED: 'date_created',
    DATE_FINISHED: 'date_finished',
});

export const DocumentSource = new Enum({
    // Internal sources
    vchasno: 'Вчасно',
    vchasno_container: 'Вчасно',
    vchasno_standalone: 'Вчасно',
    vchasno_template: 'Вчасно',

    // EDI
    edi: 'Вчасно EDI',
    edi_random_role: 'Вчасно EDI',

    // External sources
    art_office: 'Арт-Офіс',
    edoc: 'EDoc',
    ifin: 'iFin',
    ifin_doki: 'Doki.ua',
    ifin_edi: 'iFin Edi',
    medoc: 'M.E.Doc',
    papka24: 'Папка24',
    zvit: '1С:Звіт',
    zakupki: 'Zakupki.prom.ua',
});

export const DocumentUploadSource = new Enum({
    LOCAL: 'local',
    GOOGLE_DRIVE: 'google_drive',
});

// TODO[LQ]: remove it, because this classification is outdated,
// `one_sign` is no longer a document kind
export const DocumentKind = new Enum({
    // firstSignBy: owner, isOneSign: 0
    DEFAULT: 'default',
    // firstSignBy: owner, isOneSign: 1
    OWNER_ONE_SIGN_TO_FINISH: 'owner_one_sign_to_finish',
    // firstSignBy: recipient, isOneSign: 0
    RECIPIENT_SIGN_FIRST: 'recipient_sign_first',
    // firstSignBy: recipient, isOneSign: 1
    RECIPIENT_ONE_SIGN_TO_FINISH: 'recipient_one_sign_to_finish',
    INTERNAL_DOCUMENT: 'internal_document',
});

// Others
export const AdminType = new Enum({
    ADMIN: 'ADMIN',
    MASTER_ADMIN: 'MASTER_ADMIN',
    CAN_VIEW_CLIENT_DATA: 'CAN_VIEW_CLIENT_DATA',
    CAN_EDIT_CLIENT_DATA: 'CAN_EDIT_CLIENT_DATA',
    CAN_EDIT_SPECIAL_FEATURES: 'CAN_EDIT_SPECIAL_FEATURES',
});

export const DateFilterPresets = new Enum({
    ALL: 'all',
    CURRENT_MONTH: 'current_month',
    CURRENT_YEAR: 'current_year',
});

// Application
export const DocumentsFilteredByDeliveredState = new Enum({
    ALL: undefined,
    IS_DELIVERED: true,
    IS_NOT_DELIVERED: false,
});

export const LogLevel = new Enum({
    ERROR: 'error',
    WARNING: 'warning',
});

// Role Status
export const RoleStatuses = new Enum({
    ACTIVE: 'active',
    PENDING: 'pending',
    DENIED: 'denied',
    DELETED: 'deleted',
    BLOCKED_2FA: 'blocked_2fa',
    RATE_DELETED: 'rate_deleted',
});

export const SignatureFormat = new Enum({
    EXTERNAL_SEPARATED: 'external_separated',
    EXTERNAL_WRAPPED: 'external_wrapped',
    INTERNAL_SEPARATED: 'internal_separated',
    INTERNAL_WRAPPED: 'internal_wrapped',
    INTERNAL_APPENDED: 'internal_appended',
    TTN_WRAPPED: 'ttn_wrapped',
    INTERNAL_ASIC: 'internal_asic',
});

export const ACSK = new Enum({
    DEFAULT: 'default',
    CESARIS: 'cesaris',
});

export default Enum;
